<rt-heading variant="heading large-xx light">
  {{ header }}
</rt-heading>

<nav>
  @for (breadcrumb of breadcrumbs; track trackByUrl($index, breadcrumb); let isLast = $last) {
    <a
      routerLinkActive="active"
      [routerLink]="breadcrumb.url"
      [class.disabled]="breadcrumb.disabled"
    >
      <rt-icon [name]="breadcrumb.icon" margin-right-small-xx />
      {{ breadcrumb.name }}
    </a>
    @if (!isLast) {
      <rt-icon name="chevron-right" margin-lr-small-x />
    }
  }
</nav>
